import { IsoCountryCode } from 'shared/interfaces/Country';

export interface TelephonyConfiguration {
  phoneNumber: string;
}

export interface TelephonyConfigurationWithIntegrations extends Omit<TelephonyConfiguration, 'phoneNumber'> {
  phoneNumber: PhoneNumber;
}

export enum PhoneNumberProvider {
  TWILIO = 'twilio'
}

export enum TelephonyConnector {
  LIVEKIT = 'livekit'
}

export interface LivekitPhoneNumberDeploymentConfiguration {
  inboundTrunkSid: string;
  outboundTrunkSid: string;
  dispatchRuleSid: string;
  twilioSipTrunkSid: string;
}

export interface PhoneNumberDeploymentConfiguration {
  smartAssistantId: string;
  connector: TelephonyConnector;
  livekitPhoneNumberDeploymentConfiguration: LivekitPhoneNumberDeploymentConfiguration;
}

export interface TwilioPhoneNumberConfiguration {
  phoneNumberSid: string;
  phoneNumber: string;
  countryCode: IsoCountryCode;
  countryCallingCode: string;
  friendlyPhoneNumber: string;
}

export interface PhoneNumber {
  _id: string;
  provider: PhoneNumberProvider;
  user: string;
  deploymentConfiguration?: PhoneNumberDeploymentConfiguration;
  twilioPhoneNumberConfiguration: TwilioPhoneNumberConfiguration;
}

export interface PhoneNumberConfigurationTwilioDto {
  provider: PhoneNumberProvider.TWILIO;
  accountSID: string;
  authToken: string;
  phoneNumber: string;
}

export interface ImportExternalPhoneNumberDto {
  phoneNumberConfiguration: PhoneNumberConfigurationTwilioDto;
}

export interface PurchasePhoneNumberDto {
  provider: PhoneNumberProvider.TWILIO;
  phoneNumber: string;
}

export interface ExternalPhoneNumberSearchQueryDto {
  provider: PhoneNumberProvider;
  countryCode: IsoCountryCode;
  searchQuery?: string;
}

export interface ExternalPhoneNumberDto {
  phoneNumber: string;
  formattedPhoneNumber: string;
  isoCountry: IsoCountryCode;
  region: string;
  monthlyPrice: number;
  currency: string;
}
